import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AppLayout from './AppLayout';
import MusicosTab from './MusicosTab';
import { toast } from '@/components/ui/toaster';

export default function MusicosPage() {
  const { profile } = useAuth();
  const tipoGrupo = profile?.tipoGrupo || 'BANDA';

  return (
    <AppLayout userType="banda">
      <MusicosTab toast={toast} tipoGrupo={tipoGrupo} />
    </AppLayout>
  );
}
